import { useEffect, useState } from 'react';
import { getI18n } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { AppLayout } from '@/features/app';
import { PreferencesModal } from '@/features/company/components/preferences/preferences';
import { usePreferences } from '@/features/company/hooks';
import { useGetCurrentUserQuery } from '@/features/users';
import { useAppSelector } from '@/store';
import { TermsAndConditionsModal } from '@/components/ttcc-modal/new-ttcc';

export function AppPage() {
  const location = useLocation();
  const [showTermsModal, setShowTermsModal] = useState(false);

  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const { data: user } = useGetCurrentUserQuery();
  const { open, setOpen } = usePreferences({ user });

  useEffect(() => {
    getI18n().changeLanguage(user?.language as any);
  }, [user?.language]);

  useEffect(() => {
    setShowTermsModal(user?.show_modal_ttcc === true);
  }, [user]);

  if (!isLoggedIn) {
    return <Navigate to={`/auth/signin?redirectTo=${location.pathname}`} />;
  }

  return (
    <AppLayout>
      <PreferencesModal open={open} setOpen={setOpen} company={user?.company} />
      <TermsAndConditionsModal open={showTermsModal} setOpen={setShowTermsModal} />
      <Outlet />
    </AppLayout>
  );
}
